export default (to, options = { itemsPerPage: 30 }) => {
  let page = parseInt(to.query.page, 10) || 1
  if (page < 1) page = 1

  const limit = options.itemsPerPage
  const offset = (page - 1) * limit

  return {
    limit, offset
  }
}
